import { useLocation, useNavigate } from "react-router-dom";
import SuccessAnima from "../../../assets/json/success.json";
import LottieComp from "../../../components/LottieComp";
import Colors from "../../../helpers/Colors";
import { motion } from "framer-motion";

interface ArrivalTicketSuccessState {
  tenderId?: string;
  arrivalDate?: string;
  arrivedAt?: string;
}

const PageSuccessArrivalTicket = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Dikirim dari QrReader.tsx -> handleArrivalTicketScan() lewat navigate(..., { state })
  const { tenderId, arrivalDate, arrivedAt } = (location.state as ArrivalTicketSuccessState) ?? {};

  const handleNavigateToHome = () => {
    // Sesuaikan tujuan "Back"-nya kalau menu scan WHS ada di path lain
    navigate("/", { replace: true });
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen min-h-screen mx-4">
      <div className="bg-white p-8 rounded-xl shadow border text-center min-w-full">
        <LottieComp animationData={SuccessAnima} height={130} width={130} loop={false} />
        <h2 className="text-2xl font-semibold mb-2" style={{ color: Colors.text }}>
          Ticket Marked as Arrived
        </h2>
        <p className="text-sm mb-2" style={{ color: Colors.text }}>
          Barcode berhasil di-scan, shipment tercatat sudah tiba di WHS.
        </p>

        <motion.div
          className="w-full flex flex-col py-6 my-4 border-t-2 border-b-2 border-dashed gap-2"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <motion.div className="w-full flex justify-between items-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.1 }}>
            <span className="font-semibold">Tender ID</span>
            <span style={{ color: Colors.text }}>{tenderId ?? "-"}</span>
          </motion.div>
          <motion.div className="w-full flex justify-between items-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.15 }}>
            <span className="font-semibold">Arrival Date</span>
            <span style={{ color: Colors.text }}>{arrivalDate ?? "-"}</span>
          </motion.div>
          <motion.div className="w-full flex justify-between items-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.2 }}>
            <span className="font-semibold">Arrived At</span>
            <span style={{ color: Colors.text }}>{arrivedAt ?? "-"}</span>
          </motion.div>
        </motion.div>

        <motion.button
          onClick={handleNavigateToHome}
          className="p-2 border rounded-md w-full mt-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.25 }}
        >
          <span className="font-semibold" style={{ color: Colors.primary }}>
            Back
          </span>
        </motion.button>
      </div>
    </div>
  );
};

export default PageSuccessArrivalTicket;
